import React from 'react';
import ButtonModalClose from './../../elements/ButtonModalClose'
import InputShadow from './../../elements/InputShadow'

const ModalList = ({ handleChange, handleAddList, values, count, setCount }) => {
    return (
        <div className="modal fade" id="modalList" tabIndex="-1" aria-labelledby="modalList" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content"> 
                    <div className="modal-header">
                        <h5 className="modal-title" id="modalList">Ajouter une liste</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setCount(count + 1)}></button>
                    </div>


                    <div className="modal-body">
                        
                        {/* IMPUT NAME LIST */}
                        <InputShadow name='nameList' value={values.nameList} placeholder="Ajouter une liste" onChange={handleChange} /> 
                        
                        {/* BUTTON ADD GROUPE */}
                        <ButtonModalClose
                            title='Enregistrer'
                            disabled={values.nameList ? false : true}
                            onClick={() => handleAddList(values.nameList)}
                        />
                    </div>

                    
                </div>
            </div>
        </div>
    )
}

export default ModalList
